import React from "react";
import { Dialog, useMediaQuery } from "@mui/material";

interface FullScreenImageDialogProps {
  open: boolean;
  onClose: () => void;
  image?: string;
}

const FullScreenImageDialog = ({ open, onClose, image }: FullScreenImageDialogProps) => {
  const fullScreen = useMediaQuery('(max-width: 639px)');
  
  return (
    <>
      {image && (
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClick={onClose}
          sx={{ "&.MuiDialog-root .MuiPaper-root": { background: fullScreen ? "black" : "" } }}
        >
          {<img src={image} alt="image" className="w-full cover" />}
        </Dialog>
      )}
    </>
  );
};

export default FullScreenImageDialog;